<script>
import { filtersComputed, filtersMethods } from '@state/helpers'
import toggle from '@utils/design/toggle-info'

export default {
  computed: {
    ...filtersComputed,

    datePicker: function() {
      return [
        {
          key: 'daterange',
          highlight: {
            backgroundColor: '#ff8080',
            // Other properties are available too, like `height` & `borderRadius`
          },
          dates: [this.dateRangeFilters.start],
        },
      ]
    },
  },

  methods: {
    ...filtersMethods,

    selectDate: function(date) {
      console.log(date)
      if (date !== this.dateRangeFilters.start) {
        toggle()
        this.setDateRangeFiltersInsights({ dateRange: date })
      }
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info p-0 mb-0 clearfix"
    >
      <v-date-picker
        :value="dateRangeFilters.start"
        :max-date="new Date()"
        title-position="left"
        mode="range"
        color="gray"
        is-range
        is-dark
        is-inline
        is-expanded
        @input="selectDate"
      />
    </b-card-body>
  </div>
</template>

<style>
.flat {
  border-radius: 0 !important;
}
.vc-shadow {
  box-shadow: none !important;
}

.vc-rounded-lg {
  border-radius: 0 !important;
}

.vc-container {
  padding-top: 10px !important;
  background-color: #262626 !important;
  border: none !important;
  border-bottom: #23282c 1px solid !important;
}
</style>
